<hpf-user-form
        *ngIf="user"
        [user]="user"
        (create)="onCreate($event)"
    ></hpf-user-form>
<div *ngIf="!user" class="my-5 text-center">
    <nz-spin nzSimple></nz-spin>
</div>